<template>
  <dara-row>
    <dara-col
      :sm="4"
      :md="2">
      <dara-icon
        class="mt-2 py-4"
        size="xl"
        icon="question-lg" />
    </dara-col>
    <dara-col
      :sm="20"
      :md="22">
      <div class="mb--sm">
        <dara-small>{{ createdAt }}</dara-small>
        <small v-if="question.answered">
          <span
            class="badge rounded-pill bg-light text-dark fw-light ms-2 color--success">
            {{ $t('answered') }}
          </span>
        </small>
      </div>
      <dara-header v-truncate size="sm">
        <dara-question-link :id="question.id" :slug="question.slug">{{ question.title }}</dara-question-link>
      </dara-header>
      <dara-p
        v-truncate="2"
        color="regular">
        {{ question.content }}
      </dara-p>
    </dara-col>
  </dara-row>
</template>

<script>
import { formatToTimeAgo } from '@/helpers/date/date';

import DaraQuestionLink from '@/modules/question/components/QuestionLink.vue';

export default {
  name: 'QuestionListItem',
  components: {
    DaraQuestionLink,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  computed: {
    createdAt() {
      return `${formatToTimeAgo(this.question.created_at)}`;
    },
  },
};
</script>
